import React from 'react';
import { useTranslation } from "react-i18next";
import styled from 'styled-components';
import '../../App.css';
import ProjectsInfo from '../assets/data/projects';
import Footer from '../Footer';
import ProjectItem from '../ProjectItem';
import SectionTitle from '../SectionTitle';
import useReveal from '../hooks/useReveal';
import useDocumentMeta from '../hooks/useDocumentMeta';


const ProjectStyle = styled.div`
  padding: 10rem 0;
  transition: 0.4s ease-in-out;
  z-index: 1;
  position: relative;

  .projects__allItems {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
    gap: 2rem;
    margin-top: 5rem;
  }
`;

export default function Projects() {
const {t} = useTranslation(['home']);
useDocumentMeta('Projects', "A showcase of graphic design and web projects by Afonso Pereira — social media campaigns, outdoor ads, storefronts, and more.");
const [gridRef, gridVisible] = useReveal(0.05);

  return (
    <>
      <ProjectStyle>
        <div className="container">
          <SectionTitle
            heading={t('projects')}
            subheading={t('subheadingcards')}
          />
          <div className={`projects__allItems reveal ${gridVisible ? 'reveal--visible' : ''}`} ref={gridRef}>
            {ProjectsInfo.map((item) => (
              <ProjectItem
                key={item.id}
                title={item.name}
                desc={item.desc}
                desc2={item.desc2}
                img={item.img}
                img2={item.img2}
                imgVideo={item.imgVideo}
                img2Video={item.img2Video}
                url={item.url}
                tool1={item.tool1}
              />
            ))}
          </div>
        </div>
      </ProjectStyle>
      <Footer />
    </>
  );
}
